export default __webpack_public_path__ + "static/media/bo.de61c7c5.svg";